/**
 * A faithful preview of the exact Discord embed that will post — mirrors
 * server/src/services/discordPost.ts `reviewEmbed`: title = restaurant, the Three Rivers
 * water-wave mark + label, voice, footer "PGH Bites 🖤💛 • shared by a neighbor", photo if present.
 * The green accent bar matches the embed colour the server sends (Pennysaver green). Reuses
 * WaveGlyph — does NOT invent a new rating visual.
 */
import { RIVERS, DEFAULT_VOICE, type RatingValue } from '@pghbites/shared';
import { WaveGlyph } from './WaveGlyph.js';

interface EmbedPreviewProps {
  restaurant: string;
  rating: RatingValue;
  voice: string;
  draft: string;
  photoUrl?: string;
}

export function EmbedPreview({ restaurant, rating, voice, draft, photoUrl }: EmbedPreviewProps) {
  return (
    <figure className="embed-preview" aria-label="Preview of the review that will post">
      <span className="embed-accent" aria-hidden="true" />
      <div className="embed-body">
        <div className="embed-title">{restaurant || 'Your spot'}</div>
        <div className="embed-desc">
          {draft.trim() ? draft : <span className="embed-placeholder">Your review text will appear here.</span>}
        </div>
        <div className="embed-fields">
          <div className="embed-field">
            <div className="embed-field-name">Three Rivers</div>
            <div className="embed-field-value embed-rivers">
              <WaveGlyph count={Number(rating) as 0 | 1 | 2 | 3} />
              <span>{RIVERS[rating].label}</span>
            </div>
          </div>
          <div className="embed-field">
            <div className="embed-field-name">Voice</div>
            <div className="embed-field-value">{voice || DEFAULT_VOICE}</div>
          </div>
        </div>
        {photoUrl && <img className="embed-image" src={photoUrl} alt="Review photo" />}
        <div className="embed-footer">PGH Bites 🖤💛 • shared by a neighbor</div>
      </div>
    </figure>
  );
}
